import { isNil, noop } from 'lodash';

export function yupSchemaValidate(schema, data, errorMessageCreator = noop) {
    try {
        if (!isNil(schema)) {
            schema.validateSync(data, {
                abortEarly: false,
                strict: true,
            });
        }
        return true;
    } catch (error) {
        if (error.inner && error.inner.length > 0) {
            // This handles errors on specific fields within the object
            error.inner.forEach((e) => {
                errorMessageCreator(e);
            });
        } else {
            // This handles the top-level error on the object itself
            errorMessageCreator(error);
        }
        return false;
    }
}
